module.exports = __webpack_public_path__ + "img/video.59e78913.png";